import React from "react";

export default function Spinner(props) {

  const hidden = props.spinnerActive ? false : true;

  return (
    <div hidden={hidden}>
      <div
        className="pds-util-inline-flex pds-animatedIcon-rotate" aria-label="loading">
        <i data-feather="loader" aria-hidden="true"></i>
      </div>
    </div>
  );
}
